/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class CreateService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createFile
   */
  static readonly CreateFilePath = '/upload/{path}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFile$Png()` instead.
   *
   * This method sends `image/png` and handles request body of type `image/png`.
   */
  createFile$Png$Response(params: {
    path: string;
    body?: Blob
  }): Observable<StrictHttpResponse<{
'url'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CreateService.CreateFilePath, 'post');
    if (params) {
      rb.path('path', params.path, {});
      rb.body(params.body, 'image/png');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'url'?: string;
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createFile$Png$Response()` instead.
   *
   * This method sends `image/png` and handles request body of type `image/png`.
   */
  createFile$Png(params: {
    path: string;
    body?: Blob
  }): Observable<{
'url'?: string;
}> {

    return this.createFile$Png$Response(params).pipe(
      map((r: StrictHttpResponse<{
'url'?: string;
}>) => r.body as {
'url'?: string;
})
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFile$Jpeg()` instead.
   *
   * This method sends `image/jpeg` and handles request body of type `image/jpeg`.
   */
  createFile$Jpeg$Response(params: {
    path: string;
    body?: Blob
  }): Observable<StrictHttpResponse<{
'url'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CreateService.CreateFilePath, 'post');
    if (params) {
      rb.path('path', params.path, {});
      rb.body(params.body, 'image/jpeg');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'url'?: string;
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createFile$Jpeg$Response()` instead.
   *
   * This method sends `image/jpeg` and handles request body of type `image/jpeg`.
   */
  createFile$Jpeg(params: {
    path: string;
    body?: Blob
  }): Observable<{
'url'?: string;
}> {

    return this.createFile$Jpeg$Response(params).pipe(
      map((r: StrictHttpResponse<{
'url'?: string;
}>) => r.body as {
'url'?: string;
})
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFile$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createFile$FormData$Response(params: {
    path: string;
    body?: {
'file'?: Blob;
}
  }): Observable<StrictHttpResponse<{
'url'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, CreateService.CreateFilePath, 'post');
    if (params) {
      rb.path('path', params.path, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'url'?: string;
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createFile$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createFile$FormData(params: {
    path: string;
    body?: {
'file'?: Blob;
}
  }): Observable<{
'url'?: string;
}> {

    return this.createFile$FormData$Response(params).pipe(
      map((r: StrictHttpResponse<{
'url'?: string;
}>) => r.body as {
'url'?: string;
})
    );
  }

}
